<script>
export default {
    name: "MorgueDischargeReport",

    data() {

        return {
            patients: [],
            patient: {},
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                search: ``,
                wasInpatient: 0
            },
            autopsyReport: [],
            viewGatePass: false,
            viewDocuments: false,
            viewAutopsyReport: false,
            viewBill: false,
            uploadDocument: false,
            documents: [],
            dischargeDetails: {
                patientsPayments: [],
                patientWardCharges: [],
                patientDrugsnService: [],
                patientsDeposits: [],
                patientOrganReceipts: []
            },
        };
    },

    components: {

        "gate-pass-preview": () => import('./modals/GatePass.vue'),
        "autopsy-report-preview": () => import('./modals/AutopsyReport.vue'),
        "interim-bill": () => import('@/components/commons/billing/morgue/InterimBill.vue'),
        "view-document": () => import('@/components/commons/morgue/ViewDocuments.vue'),
        "upload-document-form": () => import('@/components/commons/morgue/DocumentUpload.vue'),
    },

    mounted() {

        this.fetchDischargeReport();
    },

    methods: {

        fetchDischargeReport() {
            let url = `Morgue/GetMorgueDischargeReport`;
                url += `?Datefrom=${this.filter.dateFrom}`;
                url += `&Dateto=${this.filter.dateTo}`;
                url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
                url += this.filter.wasInpatient === 1 ? `&WasInPatient=${false}` : ``;
                url += this.filter.wasInpatient === 2 ? `&WasInPatient=${true}` : ``;

            this.$root.loading=true;
            return this.$http.get(url).then(({ data }) => {
                this.patients = data;
                this.$root.loading=false;
            }).catch(() => { this.$root.loading=false; });
        },

        confirmGatePass() {
            let url = `Morgue/MorgueGatePass`;
                url += `?PatientID=${this.patient.patientID}`;

            return this.$http.post(`${url}&DischargeId=${this.patient.dischargeID}`);
        },

        fetchDocuments() {
            this.$root.loading = true;
            let url = `Morgue/GetPatientMorgueDocument`;
                url += `?PatientID=${this.patient.patientID}`;
            return this.$http.get(url).then(({ data }) => {
                this.documents = data;
                this.$root.loading = false;
                this.viewDocuments = true;
            }).catch(() => { this.$root.loading = false; });
        },



        fetchAutopsyReport() {
            this.$root.loading=true;
            this.autopsyReport=[];
            let url = `Morgue/GetAutopsyReport`;

            return this.$http.get(`${url}?PatientID=${this.patient.patientID}`)
                .then(({ data }) => {
                    this.autopsyReport = data;
                    this.$root.loading=false;
                    this.viewAutopsyReport = true;
                }).catch(() => { this.$root.loading=false; });
        },

        fetchInterimBill() {
            this.$root.loading = true;
            let url = `Morgue/GetMorgueInterimBill`;
                url += `?PatientID=${this.patient.patientID}`;
                url += `&VisitNo=${this.patient.visitNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.dischargeDetails = data;
                this.viewBill = true;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },

}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-semibold text-sm">Discharged Patients</h5>
              </template>
              <template v-slot:card-body>
                    <div class="w-full flex flex-wrap bg-gray-300 p-1">
                        <div class="flex-1">
                            <button 
                                @click.prevent="fetchAutopsyReport"
                                class="btn-sm btn-primary text-xs rounded">
                                    <i class="fa fa-list"></i> Autopsy Report</button>
                            <autopsy-report-preview 
                                :showModal="viewAutopsyReport"
                                :patient="patient"
                                :autopsyReport="autopsyReport"
                                @closeModal="viewAutopsyReport = false"
                            />       
                        </div>
                        <div class="flex-1">
                            <button 
                                @click.prevent="() => {
                                    if(!patient.patientID) return;
                                    $root.loading = true;
                                    confirmGatePass().then(() => {
                                        $root.loading = false;
                                        viewGatePass = true;
                                    });
                                }"
                                class="btn-sm btn-info text-xs rounded">
                                    <i class="fa fa-list"></i> Gate Pass</button>
                            <gate-pass-preview 
                                :showModal="viewGatePass"
                                @closeModal="viewGatePass = false"
                                :patient="patient"
                            />
                        </div>
                        <div class="flex-1">
                            <button
                                @click.prevent="() => {
                                   if(!patient.patientID) return;
                                   fetchInterimBill() 
                                }"
                                class="btn-sm btn-warning text-xs rounded">
                                    <i class="fa fa-dollar-sign"></i> Interim Bill</button>
                            <interim-bill 
                                :showModal="viewBill"
                                :patient="{ ...patient, patienT_ID: patient.patientID, }"
                                :dischargeDetails="dischargeDetails"
                                @closeModal="viewBill = false"
                            />
                        </div>
                        <div class="flex-1">
                            <button 
                                @click.prevent="() => {
                                    if(!patient.patientID) return;
                                    uploadDocument = true;
                                }"
                                class="btn-sm btn-primary text-xs rounded">
                                    <i class="fa fa-upload"></i> Upload Document</button>
                            <upload-document-form 
                                :showModal="uploadDocument"
                                :patient="{...patient, patienT_ID: patient.patientID}"
                                @closeModal="uploadDocument = false"
                            />
                        </div>
                        <div class="flex-1">
                            <button 
                                @click.prevent="() => {
                                    if(!patient.patientID) return;
                                    fetchDocuments()
                                }"
                                class="btn-sm btn-info text-xs rounded">
                                    <i class="fa fa-file"></i> View Documents</button>
                            <view-document 
                                :showModal="viewDocuments"
                                :patient="patient"
                                :documents="documents"
                                @closeModal="viewDocuments = false"
                            />
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap">
                        <div class="md:w-1/5 w-1/2 p-tiny">
                            <label for="grid-search" class="label-control">Search</label>
                            <input type="text" id="grid-search"
                                v-model.trim="filter.search"
                                class="input-sm input-control text-xs">
                        </div>
                        <div class="md:w-1/5 w-1/2 p-tiny">
                            <label for="grid-from" class="label-control">From:</label>
                            <input type="date" id="grid-from"
                                v-model.trim="filter.dateFrom"
                                class="input-sm input-control text-xs">
                        </div>
                        <div class="md:w-1/5 w-1/2 p-tiny">
                            <label for="grid-to" class="label-control">To:</label>
                            <input type="date" id="grid-to"
                                v-model.trim="filter.dateTo"
                                class="input-sm input-control text-xs">
                        </div>
                        <div class="md:w-1/5 w-1/2 p-tiny">
                            <label for="grid-was-inpatient" class="label-control">Inpatient:</label>
                            <tail-select>
                                <template v-slot:field>
                                    <select id="grid-was-inpatient" 
                                        v-model="filter.wasInpatient" 
                                        class="input-control input-sm text-xs">
                                        <option :value="0">Select option</option>
                                        <option :value="1">Not Inpatient</option>
                                        <option :value="2">Was Inpatient</option>
                                    </select>
                                </template>
                            </tail-select>
                        </div>
                        <div class="md:w-1/12 w-1/4 p-tiny mt-4">
                            <button 
                                @click.prevent="fetchDischargeReport" 
                                class="btn-sm btn-primary text-xs rounded">
                                    <i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <table class="table">
                            <thead class="bg-blue-500 text-xs">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/12">Name</th>
                                    <th class="p-tiny w-1/12">Morgue No</th>
                                    <!-- <th class="p-tiny w-1/5">IpFile No</th> -->
                                    <th class="p-tiny w-1/12">Bed</th>
                                    <!-- <th class="p-tiny flex-1">National Id</th> -->
                                    <th class="p-tiny w-1/6">Admn Date</th>
                                    <th class="p-tiny w-1/6">Brought By</th>
                                    <th class="p-tiny w-1/6">Collected By</th>
                                    
                                    <th class="p-tiny w-1/6">Burial Cert</th>
                                    <th class="p-tiny w-1/12">Burial Location</th>
                                    <th class="p-tiny flex-1">Discharged By</th>
                                    <th class="p-tiny flex-1">Select</th>
                                </tr>
                            </thead>
                            <tfoot>
                                <tr class="w-full flex text-sm">
                                    <th colspan="7" class="flex-1 p-tiny"></th>
                                    <th colspan="2" class="flex-1 p-tiny text-center">Total: {{ patients.length }}</th>
                                </tr>
                            </tfoot>
                            <tbody class="text-xs font-semibold bg-gray-200 flex flex-col items-center 
                                overflow-auto w-full" style="max-height:68vh;">
                                <tr class="flex w-full" 
                                    :class="pat.patientID == patient.patientID ? `bg-blue-300` : ``"
                                    v-for="(pat, idx) in patients" :key="idx">
                                    
                                    <td class="p-tiny w-1/12"> 
                                        <h5 class="text-sm text-gray-900">{{ pat.patient }} </h5>
                                        <h5 class="text-sm">MRN: 
                                            <span class="text-blue-800">{{ pat.patientID }}</span></h5>
                                        <h5 class="text-sm">Gender: 
                                            <span class="text-blue-800">{{ pat.gender }}</span></h5>
                                        <h5 class="text-sm">DOB: 
                                            <span class="text-blue-800">{{ pat.dob | dateFormat }}</span></h5>
                                    </td>
                                    <td class="p-tiny w-1/12"><h5 class="text-sm">
                                            <span class="font-semibold">Morgue No: 
                                                </span>{{ pat.morgueNo }}</h5>
                                                <h5 class="text-sm">
                                            <span class="font-semibold">IP File No: 
                                                </span>{{ pat.ipfileno }}</h5><h5 class="text-sm">
                                            <span class="font-semibold">National Id: 
                                                </span>{{ pat.nationalid }}</h5></td>
                                    <!-- <td class="p-tiny flex-1">{{ pat.opfileno }}</td> -->
                                    <!-- <td class="p-tiny flex-1">{{ pat.nationalid }}</td> -->
                                   <td class="p-tiny w-1/12">
                                         <h5 class="text-sm">Package: 
                                            <span class="text-blue-800">{{ pat.package }}</span></h5>
                                        <h5 class="text-sm">Bed: 
                                            <span class="text-blue-800">{{ pat.bed }}</span></h5>
                                         
                                    </td>
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm">Adm Date: 
                                            <span class="text-blue-800">{{ pat.dateAdmitted | dateFormat }}</span></h5>
                                            <h5 class="text-sm">Discharge Date: 
                                            <span class="text-blue-800">{{ pat.dischargeDate | dateFormat }}</span></h5>
                                            <h5 class="text-sm">days: 
                                            <span class="text-blue-800">{{ pat.days}}</span></h5>
                                            <h5 class="text-sm">Admitted By:
                                            <span class="text-blue-800">{{ pat.admittedByUser}}</span></h5>
                                        </td>
                                         <td class="p-tiny w-1/6">
                                        <h5 class="text-sm">Name: 
                                            <span class="text-blue-800">{{ pat.broughtBy }}</span></h5>
                                        <h5 class="text-sm">Id No: 
                                            <span class="text-blue-800">{{ pat.broughtByIdNo }}</span></h5>
                                            <h5 class="text-sm">Relationship: 
                                            <span class="text-blue-800">{{ pat.broughtByRelationship }}</span></h5>
                                            <h5 class="text-sm">Tel No: 
                                            <span class="text-blue-800">{{ pat.broughtByTelNo }}</span></h5>
                                    </td>
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm">Name: 
                                            <span class="text-blue-800">{{ pat.collectedBy }}</span></h5>
                                        <h5 class="text-sm">Id No: 
                                            <span class="text-blue-800">{{ pat.collectedByIdNo }}</span></h5>
                                            <h5 class="text-sm">Relationship: 
                                            <span class="text-blue-800">{{ pat.collectedByRelationship }}</span></h5>
                                            <h5 class="text-sm">Tel No: 
                                            <span class="text-blue-800">{{ pat.collectedByTel }}</span></h5>
                                    </td>
                                       <td class="p-tiny w-1/6">
                                        <h5 class="text-sm">Burial Permit: 
                                            <span class="text-blue-800">{{ pat.burialPermit }}</span></h5>
                                        <h5 class="text-sm">Death Cert No: 
                                            <span class="text-blue-800">{{ pat.deathCertNo}}</span></h5>
                                        </td>
                                        <td class="p-tiny w-1/12"> 
                                        <h5 class="text-sm">Village: 
                                            <span class="text-blue-800">
                                                {{ pat.village || `-` }}</span></h5>
                                        <h5 class="text-sm">Location: 
                                            <span class="text-blue-800">
                                                {{ pat.location || `-` }}</span></h5>
                                        <h5 class="text-sm">Subcounty: 
                                            <span class="text-blue-800">
                                                {{ pat.subcounty || `-` }}</span></h5>
                                    </td>
                                    <td class="p-tiny flex-1">
                                        {{ pat.userName }}  
                                     </td>
                                    <td class="p-tiny flex-1">
                                        <button 
                                            @click.prevent="patient = pat" 
                                            class="btn-sm btn-primary text-xs rounded m-px">
                                                <i class="fa fa-check"></i> Select</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>